import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import parse from "html-react-parser";
import { BASE_URL } from "../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBrand, setFilter } from "../../redux/slice/Slice";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
function Internationaloprtunites({ data }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [hoveredItemIndex, setHoveredItemIndex] = useState(null);
  const handleMouseEnter = (index) => setHoveredItemIndex(index);
  const handleMouseLeave = () => setHoveredItemIndex(null);
  const item = data?.slice(0, 4)
  const mainCarouselItems = data?.slice(0, 4)?.map((item, index) => (
    <div className={`{"bg-[#f9f8f8] rounded-lg overflow-hidden hover:[box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%)] p-3 mx-2  ${data?.length == 1 ? "max-w-[350px] bg-[#f9f8f8]" : "bg-[#f9f8f8]"}`} onMouseEnter={() => handleMouseEnter(index)}
      onMouseLeave={handleMouseLeave}>
      <div className="flex justify-center items-center">
        <img
          className="w-full h-32 border border-gray-200 rounded-md cursor-pointer"
          src={`${item?.upload_logo}`}
          alt="Bata"
        />
      </div>
      {/* Hover Carousel */}
      {/* {hoveredItemIndex === index && (
        <div className="absolute inset-0 bg-opacity-90 flex items-center justify-center rounded-md h-36 ">
          <AliceCarousel
            mouseTracking
            items={data?.map((item, i) => (
              <div className="max-w-[380px] mx-auto h-[150px] mt-3">
                <img
                  key={i}
                  className="h-[150px] w-full rounded-md"
                  src={item.upload_banner}
                  alt={`Hover-${i}`}
                />
              </div>
            ))}
            autoPlay
            infinite
            autoPlayInterval={1000}
            disableDotsControls
            disableButtonsControls
          />
        </div>
      )} */}
      <div className="mt-3">
        <p className="text-sm text-[#0C5399]  mt-2">
          {" "}
          {item?.category?.name}
        </p>
        <h3 className="text-xl font-bold text-gray-800 text-ellipsis overflow-hidden whitespace-nowrap mt-2">
          {" "}
          {item?.brand_name}
        </h3>
        <p className="text-sm text-gray-600 max-w-[400px] overflow-hidden overflow-ellipsis line-clamp-1 mt-2">
          {parse(item?.business_overview)}
        </p>
        <div className="border-2 rounded-md border-gray-600 mt-3 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
          <p
            className=""
            onClick={() =>
              navigate(`/franchise-opportunity/${item?.brand_url}`, { state: { item: item } })
            }
          >
            Explore
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </p>
        </div>
      </div>
    </div>

  ));
  return (
    <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mb-4">
      <div className="mt-9 mb-5">
        <h1 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3 ">
          Top International{" "}
          <span className="text-secondaryColor">Opportunities</span>
        </h1>
        <hr />
      </div>
   

<div className={`${item?.length === 1 || item?.length === 2 || item?.length === 3 ? "Carsouleitemwidth" : ""}`}>
        {item?.length === 1 || item?.length === 2 || item?.length === 3 ?
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:gap-5 mx-auto md:gap-2-important lg:gap-0-important xl:gap-0-important gap-4">
            {item?.map((item, index) => (
              <div className={`{"bg-[#f9f8f8] rounded-lg overflow-hidden hover:[box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%)] p-3 mx-2  ${data?.length == 1 ? "max-w-[350px] bg-[#f9f8f8]" : "bg-[#f9f8f8]"}`} onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}>
              <div className="flex justify-center items-center">
                <img
                  className="w-full h-32 border border-gray-200 rounded-md cursor-pointer"
                  src={`${item?.upload_logo}`}
                  alt="Bata"
                />
              </div>
              {/* Hover Carousel */}
              {/* {hoveredItemIndex === index && (
                <div className="absolute inset-0 bg-opacity-90 flex items-center justify-center rounded-md h-36 ">
                  <AliceCarousel
                    mouseTracking
                    items={data?.map((item, i) => (
                      <div className="max-w-[380px] mx-auto h-[150px] mt-3">
                        <img
                          key={i}
                          className="h-[150px] w-full rounded-md"
                          src={item.upload_banner}
                          alt={`Hover-${i}`}
                        />
                      </div>
                    ))}
                    autoPlay
                    infinite
                    autoPlayInterval={1000}
                    disableDotsControls
                    disableButtonsControls
                  />
                </div>
              )} */}
              <div className="mt-3">
                <p className="text-sm text-[#0C5399]  mt-2">
                  {" "}
                  {item?.category?.name}
                </p>
                <h3 className="text-xl font-bold text-gray-800 text-ellipsis overflow-hidden whitespace-nowrap mt-2">
                  {" "}
                  {item?.brand_name}
                </h3>
                <p className="text-sm text-gray-600 max-w-[400px] overflow-hidden overflow-ellipsis line-clamp-1 mt-2">
                  {parse(item?.business_overview)}
                </p>
                <div className="border-2 rounded-md border-gray-600 mt-3 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
                  <p
                    className=""
                    onClick={() =>
                      navigate(`/franchise-opportunity/${item?.brand_url}`, { state: { item: item } })
                    }
                  >
                    Explore
                    <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                  </p>
                </div>
              </div>
            </div>
            ))
            } </div> : (
              <AliceCarousel
        mouseTracking
        items={mainCarouselItems}
        autoPlay
        infinite
        autoPlayInterval={2000}
        disableDotsControls
        disableButtonsControls
        responsive={{
          0: { items: 1 },
          768: { items: 2 },
          1024: { items: 3 },
          1280: { items: 4 },
        }}
      />
          )}


      </div>
      <div
        className="flex justify-center items-center 2xl:mt-5 xl:mt-5 md:mt-5 mt-2"
        onClick={() => {
          navigate(`/products/best-bussinessdetails`, { state: { item: data } });
          dispatch(setFilter(data));
          dispatch(setBrand("Top International Opportunities"));
        }}
      >
        <div className="border-2 border-[#4A5661] bg-[#4A5661] mb-5 text-white border-gray-600 text-center text-sm text-gray-800 py-2 w-60 rounded-md 2xl:mt-[50px] xl:mt-[50px] lg:mt-[50px] md:mt-[50px] mt-[30px] cursor-pointer hover:[box-shadow:0_0_10px_0_#4a5661_inset,_0_0_20px_2px_#4a5661]">
          <p className="">
            VIEW ALL
            <FontAwesomeIcon icon={faArrowRight} className="ml-1" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default Internationaloprtunites;
